import axios from "axios";
import { getCorrelationId } from "../utils/correlation-id";
import { getEnvVar } from "../utils/get-env";

export const gatewayEventScheduler = axios.create({
  baseURL: process.env.NODE_ENV === "local" ? "http://localhost:3333" : getEnvVar("REACT_APP_API_URL_EVENT"),
  timeout: 90000,
  headers: {
    "x-correlation-id": getCorrelationId(),
  },
});
